export default __webpack_public_path__ + "static/media/sendButton.4ba9ae72.svg";